import React from 'react';
import { Segment, Form, Header, Button } from 'semantic-ui-react';
import axios from 'axios';
import download from 'downloadjs';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer, toast } from 'react-toastify';
import * as mock2 from '../../DegreeDocumentPrint/mockv2';
import { fetchStudyCycle, fetchDocumentTypes, fetchAcademicYears } from '../../Lookups/util';
import DataTable from '../../DegreeDocumentPrint/DataTable';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class Certificates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedData: [],
            studyCycles: [],
            languages: [],
            documentReasons: [],
            language: '',
            studyCycle: '',
            documentType: '',
            documentReason: '',
            issueDate: new Date(),
            firstName: null,
            lastName: null,
            index: null,
            academicYearId: null,
            academicYears: [],

            studyCycleErr: false,
            academicYearIdErr: false,
            showStudents: false
        };

        this.fetchDocReasons = this.fetchDocReasons.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.changeStep = this.changeStep.bind(this);
        this.printCertificates = this.printCertificates.bind(this);

        this.onDataChange = this.onDataChange.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);
    }

    componentDidMount() {
        this.setState({
            language: 1,
            languages: [
                {
                    text: window.$locale === 'en' ? 'B/H/S language' : 'B/H/S jezik',
                    key: 1,
                    value: 1
                },
                {
                    text: window.$locale === 'en' ? 'English language' : 'Engleski jezik',
                    key: 2,
                    value: 2
                },
            ]
        });

        axios.all([fetchStudyCycle(), fetchDocumentTypes(), fetchAcademicYears()])
            .then(axios.spread((sCyclesRes, docTypesRes, academicYearsRes) => {
                const studyCycles = sCyclesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));

                const documentType = docTypesRes.data.map(el => ({
                    ...el, value: el.id, key: el.id, text: el.name
                })).filter(e => e.name === 'Uvjerenje o završenom ciklusu studija').id;

                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles, documentType, academicYears
                });
                // this.fetchDocReasons(documentTypes[0].id);
            }))
            .catch(err => {
                console.log('Failed to fetch studyCycles or doc types');
            });
    }

    fetchDocReasons(id) {
        axios.get('/document-reasons/get-reasons/' + id)
            .then(res => {
                this.setState({
                    documentReasons: res.data.map(el => ({
                        ...el, value: el.id, key: el.id, name: el.displayName
                    })),
                    documentReason: res.data[0].id
                });
            })
            .catch(err => console.log('Failed to fetch document reasons'));
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    onDataChange(row) {
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { data, selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === data.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: data });
        }
    }

    getStudents() {
        const {
            studyCycle, firstName, lastName, index, academicYearId
        } = this.state;
        if (!studyCycle || !academicYearId) {
            toast('Niste unijeli sva obavezna polja.');
            if (!studyCycle) { this.setState({ studyCycleErr: true }); } else { this.setState({ studyCycleErr: false }); }
            if (!academicYearId) { this.setState({ academicYearIdErr: true }); } else { this.setState({ academicYearIdErr: false }); }
        } else {
            this.setState({ studyCycleErr: false });
            let params = {
                studyCycle, graduated: true
            };
            if (firstName) params = { ...params, firstName };
            if (lastName) params = { ...params, lastName };
            if (index) params = { ...params, documentNumber: index };
            if (academicYearId) params = { ...params, academicYearId };

            axios.post('/graduation-documents/', { ...params })
                .then(res => {
                    this.setState({
                        data: res.data.map(el => ({
                            ...el,
                            date: moment(el.dateOfGraduation).format('D. M. YYYY.'),
                            department: el.departmentsSPOU[0].organizationalUnitName,
                        })),
                        showStudents: true
                    });
                })
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
    }

    changeStep(step) {
        this.setState({ step });
    }

    printCertificates() {
        const ids = this.state.selectedData.map(e => e.id);
        const { studyCycle } = this.state;
        if (ids.length === 0) return;
        const params = {
            language: this.state.language === 1 ? window.$locale === 'hr' ? 'hr' : 'bs' : 'en', ids, issueDate: moment(this.state.issueDate).format(), studyCycle, withLogo: false
        };
        axios({
            method: 'post',
            url: '/graduation-documents/print-completed-study-cycle-certificate',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })

            .then(res => this.setState({ afterPrintRequest: { success: true }, selectedData: [] }))
            .catch(err => this.setState({ error: true, errorText: 'failed to download documents' }));
    }


    render() {
        const {
            studyCycle, studyCycles, issueDate, academicYearId, academicYears, language, languages
        } = this.state;
        return (
            <div>
                <Header as="h1">Uvjerenje o završenom ciklusu</Header>
                <Segment.Group raised>
                    <Segment>
                        {/* <h3>Opcije za štampanje</h3> */}
                        <h3>Studenti</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Broj diplome</label>
                                    <input
                                        value={this.state.index}
                                        onChange={(e) => this.setState({ index: e.target.value })}
                                        name="index"
                                        placeholder="Unesite broj diplome"
                                    />
                                </Form.Field>

                            </Form.Group>
                        </Form>
                        <br />
                        {/* <Form>
                                <Form.Field>
                                    <label>Razlog štampanja</label>
                                    <Form.Select
                                        value={this.state.documentReason}
                                        onChange={this.handleInputChange}
                                        name="documentReason"
                                        options={this.state.documentReasons}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                            </Form>
                            */}
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required error={this.state.studyCycleErr} >
                                    <label >Ciklus studija</label>
                                    <Form.Select
                                        value={studyCycle}
                                        onChange={this.handleInputChange}
                                        name="studyCycle"
                                        options={studyCycles}
                                        search
                                        fluid
                                        placeholder="Odaberite ciklus studija"
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.academicYearIdErr}>
                                    <label>Akademska godina</label>
                                    <Form.Select
                                        value={academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={academicYears}
                                        search
                                        fluid
                                        placeholder="Odaberite akademsku godinu"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Datum izdavanja (prikazuje se na uvjerenju)</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        defaultValue={new Date()}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'issueDate')}
                                        value={issueDate}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                        <br />

                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <label>Jezik</label>
                                    <Form.Select
                                        value={language}
                                        onChange={this.handleInputChange}
                                        name="language"
                                        options={languages}
                                        search
                                        fluid
                                    />
                                </Form.Field>
                                <Form.Field />
                                <Form.Field />
                            </Form.Group>
                        </Form>
                        <br />
                        <Button
                            color="blue"
                            onClick={this.getStudents}
                            floated="right"
                        >Prikaži studente</Button>

                        <br />
                        {this.state.showStudents && <div><br /><br /><DataTable
                            data={this.state.data}
                            selectedData={this.state.selectedData}
                            onDataChange={this.onDataChange}
                            selectAll={this.selectAll}
                            studentService
                            changeStep={this.changeStep}
                            printCertificates={this.printCertificates}
                            studyCycle={this.state.studyCycle}
                        /></div>}
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Certificates/Certificates.js